import { IAgricultureHumidityLevels } from '@@/agriculture/ts';

export const AGRICULTURE_HUMIDITY_LEVELS: IAgricultureHumidityLevels = {
  dry: {
    min: -Infinity,
    max: 14,
  },
  medium: {
    min: 14,
    max: 15.5,
  },
  wet: {
    min: 15.5,
    max: Infinity,
  },
};

export const AGRICULTURE_HUMIDITY_LEVELS_COLORS: {
  [key in keyof IAgricultureHumidityLevels]: string;
} = {
  dry: '#E73A42',
  medium: '#66B28A',
  wet: '#409BFF',
};
